import 'nodelist-foreach-polyfill'
import 'formdata-polyfill'

window.addEventListener('DOMContentLoaded', () => {
  const clearAllFormData = () => {
    allCheckboxes.forEach((el) => el.checked = false)
    regionSelection.selectedIndex = 0
    prefectureSelection.selectedIndex = 0
    specilitySelection.selectedIndex = 0
    keyword.value = ''
  }

  const regionSelection = document.getElementById('sites_video_search_form_root_region_id')
  const prefectureSelection = document.getElementById('sites_video_search_form_root_prefecture_id')
  const specilitySelection = document.getElementById('sites_video_search_form_root_speciality_id')
  const clearButton = document.getElementById('js-clear')
  const allCheckboxes = document.querySelectorAll('input[type=checkbox]')
  const keyword = document.getElementById('sites_video_search_form_root_keyword')

  clearButton.addEventListener('click', () => {
    clearAllFormData()
  })

  const nameForm = document.getElementById('name-form')
  const conditionForm = document.getElementById('condition-form')
  const submitButtons = document.querySelectorAll('.js-submit')

  submitButtons.forEach((el) => {
    const target = el.dataset.target
    if (target == 'condition-form'){
      el.addEventListener('click', onConditionFormSubmit);
    } else if (target == 'name-form') {
      el.addEventListener('click', onNameFormSubmit)
    }
  });

  function onsubmit(form) {
    const formData = new FormData(form);
    const url = new URL(form.action, window.location.origin);

    // Remove all existing search parameters
    url.search = '';

    // Append only non-empty parameters
    for (const [key, value] of formData.entries()) {
      if (value.trim() !== '') {
        url.searchParams.append(key, value);
      }
    }

    window.location.href = url.toString();
  }

  conditionForm.addEventListener('submit', onConditionFormSubmit);
  nameForm.addEventListener('submit', onNameFormSubmit);

  function onNameFormSubmit(e) {
    e.preventDefault();
    onsubmit(nameForm);
  }

  function onConditionFormSubmit(e) {
    e.preventDefault();
    onsubmit(conditionForm)
  }
})
